<template>
  <div>
    <b-form @submit.prevent>
      <b-row>

        <!-- first name -->
        <b-col cols="12">
          <b-form-group
            label="Max enabled devices"
            label-for="vi-max-devices"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="CpuIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-max-devices"
                v-model="settings.globalMaxEnabledDevices"
                placeholder="Max enabled devices"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- checkbox -->
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="checkbox-4"
              v-model="settings.emailValidation"
              name="checkbox-4"
              value="true"
            >
              Email Validation
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Updated At: {{ settings.updated }}</span>
          </div>
        </b-col>
        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveSettings"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      settings: {},
    }
  },
  mounted() {
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(`${this.$readerURL}/admin/settings`,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.settings = response.data
        this.loader('none')
        return response
      }).catch(error => {
        this.loader('none')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error,
            icon: 'EditIcon',
            variant: 'error',
          },
        })
      })
    })
  },
  methods: {
    saveSettings() {
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(`${this.$readerURL}/admin/settings`, this.settings,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.settings = response.data
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
